import { CellValueChangedEvent } from 'ag-grid-community';
import { useCallback } from 'react';
import { HRM1040_R01EducationDto, HRM1040_R01FamilyDto } from '../Dto_HRM1040_R01';
import { useHRM1040_R01Store } from '../Store_HRM1040_R01';

/**
 * 가족·학력 셀 변경을 해당 목록에 반영하고 수정 상태를 기록한다.
 * @returns 가족 그리드와 학력 그리드의 onCellValueChanged 함수
 */
export const useHRM1040_R01CellChange = () => {
    // 화면 Store에서 valueIndex로 가족·학력 행을 교체하는 함수를 가져온다.
    const { updateHRM1040_R01FamilyList, updateHRM1040_R01EducationList } = useHRM1040_R01Store();
    /**
     * 가족 셀 값이 실제로 바뀌었을 때만 행을 수정 상태로 저장한다.
     * @param event 변경된 셀 정보
     */
    const handleFamilyCellChange = useCallback((event: CellValueChangedEvent<HRM1040_R01FamilyDto>) => {
        if (!event.data || event.oldValue === event.newValue) return;
        updateHRM1040_R01FamilyList(event.data.valueIndex, { ...event.data, isModified: true });
    }, [updateHRM1040_R01FamilyList]);
    /**
     * 학력 셀 값이 실제로 바뀌었을 때만 행을 수정 상태로 저장한다.
     * @param event 변경된 셀 정보
     */
    const handleEducationCellChange = useCallback((event: CellValueChangedEvent<HRM1040_R01EducationDto>) => {
        if (!event.data || event.oldValue === event.newValue) return;
        updateHRM1040_R01EducationList(event.data.valueIndex, { ...event.data, isModified: true });
    }, [updateHRM1040_R01EducationList]);
    return { handleFamilyCellChange, handleEducationCellChange };
};
